/**
 * Workflow Derived Atoms - Computed atoms derived from core workflow and phase atoms
 *
 * These atoms combine or transform data from core atoms to provide convenient views
 */

import { atom } from "jotai";
import type { WorkflowWithPhases } from "@/isomorphic/schemas/workflow";
import { currentWorkflowAtom } from "../core/workflows";
import { workflowPhasesAtomFamily } from "../core/phases";

/**
 * Current workflow with phases (derived from currentWorkflowAtom + phases)
 * Combines the current workflow with its phases for components that need the full context
 * Returns WorkflowWithPhases | null
 */
export const currentWorkflowWithPhasesAtom = atom<WorkflowWithPhases | null>((get) => {
  const workflow = get(currentWorkflowAtom);
  if (!workflow) return null;

  const phases = get(workflowPhasesAtomFamily(workflow.id));

  return {
    ...workflow,
    phases,
  };
});
